<template>
  <span :class="badgeClass">
    {{ translatedStatus }}
  </span>
</template>

<script>
import { SubscriptionStatusTranslationMap } from "@/enums/status";

export default {
  name: "SubscriptionStatuses",
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    badgeClass() {
      if (!this.status || this.status === '-') return '';

      const statusMap = {
        'processing': 'badge badge-processing',
        'authorized': 'badge badge-paid',
        'paid': 'badge badge-paid',
        'canceled': 'badge badge-canceled',
        'ended': 'badge badge-ended',
        'refunded': 'badge badge-refunded',
        'waiting_payment': 'badge badge-waiting_payment',
        'pending_payment': 'badge badge-pending_payment',
        'refund_pending': 'badge badge-refund_pending',
        'pending_refund': 'badge badge-pending_refund',
        'refused': 'badge badge-refused',
        'chargedback': 'badge badge-chargedback',
        'delayed': 'badge badge-delayed',
        'trialing': 'badge badge-trialing',
        'unpaid': 'badge badge-unpaid',
      };
      return statusMap[this.status.toLowerCase()] || '';
    },
    translatedStatus() {
      return this.$t(SubscriptionStatusTranslationMap[this.status])
    }
  }
}
</script>

<style scoped>
.badge {
  height: 25px;
  border-radius: 16px;
  padding: 8px 12px 8px 12px;
  display: inline;
}

.badge-paid {
  background: #D1FAE5;
  color: #065F46
}

.badge-processing {
  background: #D6F0FF;
  color: #0854C5;
}

.badge-authorized {
  background: #D6F0FF;
  color: #0854C5;
}

.badge-refused {
  background: #FEE2E2;
  color: #92400E;
}

.badge-unpaid {
  background: #FEF3C7;
  color: #92400E;
}

.badge-refunded {
  background: #F3F4F6;
  color: #1F2937;
}

.badge-chargedback {
  background: #D1FAE5;
  color: #000000
}

.badge-canceled {
  background: #D1FAE5;
  color: #000000
}

.badge-ended {
  background: #F2F4F7;
  color: #344054;
}

.badge-trialing {
  background: #FEF3C7;
  color: #92400E;
}

.badge-waiting_payment {
  background: #FEF3C7;
  color: #92400E;
}

.badge-pending_payment {
  background: #FEF3C7;
  color: #92400E;
}

.badge-refund_pending {
  background: #FEF3C7;
  color: #92400E;
}

.badge-canceled {
  background: #FEE4E2;
  color: #B42318;
}

.badge-ended {
  background: #F2F4F7;
  color: #344054;
}

.badge-unpaid {
  background: #FEF3C7;
  color: #92400E;
}

.badge-delayed {
  background: #FEF3C7;
  color: #92400E;
}

.badge-created {
  background: #D6F0FF;
  color: #0854C5;
}
</style>